// removed by extract-text-webpack-plugin
module.exports = {"component":"_3JU0RH0CCwZFWUiIvLy2j4","container":"_1srOSz3kGS-dBQzV7oVaxw","notes":"_3xp2LM2suzDAxmqb0F_d24","actions":"_1djcxNK3t5WpI73IicFuwn","cta":"nF2f4I641DEfBIv51-wb9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordListItem/HealthRecordListItem.css
// module id = 1264
// module chunks = 0